import { apiAction } from '@store/middlewares/api/ApiActionCreators';
import { ENDPOINT_GET_CHAT_AUTH_TOKEN } from '@utilities/apiConstants';
import endpointTemplateToUrl from '@utilities/endpointTemplateToUrl';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';
import ApiRestMethod from '@utilities/apiEndpoints/ApiRestMethod';
import ApiService from '@utilities/apiEndpoints/ApiService';
import { CancelPolicy } from '@interfaces/CancelPolicy';
import { GET_CHAT_AUTH_TOKEN } from '@store/actions/types';

export interface GetChatAuthTokenResponse {
	authToken: string;
}

export const getChatAuthToken = (userId: string, requestOverride: Partial<ApiActionPayload<GetChatAuthTokenResponse>>) => {
	const url = endpointTemplateToUrl(ENDPOINT_GET_CHAT_AUTH_TOKEN, { mongoUserId: userId });

	return apiAction({
		url,
		method: ApiRestMethod.GET,
		apiService: ApiService.USER,
		includeAccessToken: true,
		label: GET_CHAT_AUTH_TOKEN,
		cancelPolicy: CancelPolicy.NO_DUPLICATE_PATH,
		shouldDisableLoadIndicator: true,
		...requestOverride
	})
}
